import styled from 'styled-components'
export const FirstSectionWrap = styled.section`
    height:416px;
    background: #007aff;
    .flexSpaceBetween{
        display:flex;
        justify-content:space-between;
        align-items:center;
    }
    img{
        margin-right:50px
    }
`;
export const AboutBlock = styled.div`
    width:1200px;
    margin:35px auto;
    height: 352px;
    background: rgba(0,122,255,0.06);
    box-sizing:border-box;
    padding: 0 38px;
    overflow: hidden;
    h2{
        font-size: 28px;
        font-weight: bold;
        color: #15213c;
        margin-top:28px;
    }
    div{
        width: 32px;
        height: 4px;
        background: #007aff;
        border-radius: 3px;
        margin-top:10px;
        margin-bottom:16px;
    }
    p{
        font-size: 14px;
        color: rgba(21,33,60,0.80);
        line-height: 22px;
    }
    
`;
export const BlockTitle = styled.h1`
    font-size: 36px;
    font-weight: bold;
    color: #fff;
    margin-left:50px;
`;

export const BlockSlogan = styled.p`
    font-size: 28px;
    color: #ffffff;
    margin-top: 20px;
    margin-left:50px;
`;